/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import axios from "axios";

import { HeaderWithBottomLine } from "../Master/CpOnbordingSteps/HeaderWithBottomLine";
import {
  Row,
  Col,
  Form,
  Input,
  Select,
  Button,
  message,
  Space,
  Spin,
} from "antd";
import { camelCase, capitalize, capitalise } from "../../utils";

const AccountAddress = ({ form, bookingDetails }) => {
  const [pinLoading, setPinLoading] = useState(false);
  const [data, setData] = useState("");

  // useEffect(() => {
  //   setData({
  //     name: bookingDetails?.senderName,
  //     address: bookingDetails?.senderAddressLine1,
  //   });
  //   /// do any thing else
  // }, [row]);
  // const pincodeHandle = async (values) => {
  //   if (values.target.value.length > 5) {
  //     setPinLoading(true);

  //     try {
  //       let response = await fetch(
  //         `https://api.postalpincode.in/pincode/${values.target.value}`
  //       );
  //       let res = await response.json();
  //       if (res?.length > 0) {
  //         {
  //           res?.map((data) => {
  //             data?.PostOffice?.map((data) => {
  //               console.log(data, "data");
  //               form.setFieldsValue({
  //                 city: data?.District,
  //                 state: data?.State,
  //               });
  //             });
  //           });
  //         }
  //         setPinLoading(false);
  //       }
  //     } catch (error) {
  //       setPinLoading(false);
  //     }
  //   } else if (values.target.value.length < 6) {
  //     form.setFieldsValue({
  //       city: "",
  //       state: "",
  //     });
  //   }
  // };
  return (
    <Spin spinning={pinLoading}>
      <div className="account-address-container">
        <HeaderWithBottomLine text={"Address Details"} icon={false} />
        <div style={{ margin: "20px 0" }}>
          <div
            className="account-address-container-box"
            style={{ padding: "15px 30px" }}
          >
            <p
              style={{
                fontWeight: 500,
                fontSize: "16px",
                lineHeight: "32px",
                letterSpacing: "-0.25px",
                color: "#061624",
              }}
            >
              Sender Address
            </p>
            <p
              style={{
                fontWeight: 500,
                fontSize: "14px",
                lineHeight: "32px",
                letterSpacing: "-0.25px",
                color: "#061624",
              }}
            >
              {capitalize(bookingDetails?.addressDetails?.senderName)}
              {/* Santosh kumar */}
            </p>
            <p>
              {bookingDetails?.addressDetails?.senderAddressLine1}
              {/* #758, 4th Floor, 19th Main, Dollar Scheme Layout, HSR Layout, 2nd
              Sector, Bengaluru, Karnataka 560102 */}
            </p>
          </div>
        </div>
        <div
          style={{
            fontWeight: 500,
            fontSize: "16px",
            lineHeight: "32px",
            letterSpacing: "-0.25px",
            color: "#061624",
            marginBottom: "29px",
          }}
        >
          Receiver Address
        </div>
        <Space
          direction="vertical"
          size="middle"
          style={{
            display: "flex",
          }}
        >
          <Row className="global-form-row" gutter={32}>
            <Col span={6}>
              <Form.Item
                label="Name"
                name="name"
                rules={[
                  {
                    required: true,
                    message: "Please give a name",
                  },
                ]}
              >
                <Input
                  placeholder="Enter name here"
                  onKeyPress={(e) => {
                    if (/[^A-Za-z_(-) ]/.test(e.key)) {
                      e.preventDefault();
                    }
                    if (e.target.value.length >= 20) {
                      e.preventDefault();
                    }
                  }}
                  onKeyDown={(e) => {
                    if (!/[a-zA-Z]/.test(e.target.value)) e.target.value = "";
                  }}
                  onBlur={(e) => form.setFieldValue("name", capitalise(e))}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                label="Address line 1"
                name="addressLine1"
                rules={[
                  {
                    required: true,
                    message: "Please give address",
                  },
                ]}
              >
                <Input placeholder="Enter address line 1" />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item label="Address line 2" name="addressLine2">
                <Input placeholder="Enter address line 2" />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                label="PIN code"
                name="pincode"
                // rules={[
                //   {
                //     required: true,
                //     message: "Please enter a valid PIN code",
                //   },
                //   () => ({
                //     validator(rule, value = "") {
                //       if (parseInt(value.substring(1, 0)) === 0) {
                //         return Promise.reject("PIN code should not be 0");
                //       }
                //       if (value.length > 0 && value.length < 6) {
                //         return Promise.reject("Please enter 6 digits PIN code");
                //       } else {
                //         return Promise.resolve();
                //       }
                //     },
                //   }),
                // ]}
              >
                <Input
                  placeholder="Enter pincode"
                  // onChange={pincodeHandle}
                  onKeyPress={(e) => {
                    if (/[^0-9]/.test(e.key)) {
                      e.preventDefault();
                    }
                    if (e.target.value.length >= 6) {
                      e.preventDefault();
                    }
                  }}
                  disabled
                />
              </Form.Item>
            </Col>
          </Row>

          <Row className="global-form-row" gutter={32}>
            <Col span={6}>
              <Form.Item
                label="Area name"
                name="areaName"
                rules={[
                  {
                    required: true,
                    message: "Please give area name",
                  },
                ]}
              >
                <Input placeholder="Enter area name" disabled />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item label="City" name="city">
                <Input disabled />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item label="State" name="state">
                <Input disabled />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                label="Mobile number"
                name="mobileNumber"
                rules={[
                  {
                    required: true,
                    message: "Please enter phone number",
                  },
                  () => ({
                    validator(rule, value = "") {
                      if (parseInt(value.substring(1, 0)) === 0) {
                        return Promise.reject("Mobile number should not be 0");
                      }
                      if (value.length > 0 && value.length < 10) {
                        return Promise.reject(
                          "Please enter 10 digits phone number"
                        );
                      } else {
                        return Promise.resolve();
                      }
                    },
                  }),
                ]}
              >
                <Input
                  placeholder="Enter phone number"
                  onKeyPress={(e) => {
                    if (/[^0-9]/.test(e.key)) {
                      e.preventDefault();
                    }
                    if (e.target.value.length >= 10) {
                      e.preventDefault();
                    }
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                label="Email Address"
                name="receiverEmail"
                rules={[
                  {
                    type: "email",
                    message: "Give the correct email",
                  },
                ]}
              >
                <Input
                  placeholder="Enter email address"
                  onBlur={(e) =>
                    form.setFieldValue(
                      "receiverEmail",
                      e.target.value.toLocaleLowerCase()
                    )
                  }
                />
              </Form.Item>
            </Col>
          </Row>
        </Space>
      </div>
    </Spin>
  );
};

export default AccountAddress;
